// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".documentMobile .react-pdf__Page__canvas{width:100% !important;height:auto !important}.document .react-pdf__Page__canvas{width:unset !important;height:unset !important}", ""]);
// Exports
module.exports = exports;
